module.exports = __webpack_public_path__ + "img/sso-icon.399624b8.png";